import type { SymbolKey } from '@/entities/symbol/types';

function isEmptySymbol(symbol: SymbolKey | null | undefined) {
  return symbol === null || symbol === undefined || symbol.Code === '';
}

export default isEmptySymbol;
